import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const vinVersionHistorySlice = createSlice({
  name: 'vinVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default vinVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = vinVersionHistorySlice.actions;
